export { default as TechnologyStacksPage } from "./pages/TechnologyStacksPage";
export { default as TechnologyStackComparisonPage } from "./pages/TechnologyStackComparisonPage";
export { default as Addbackendtechstack } from "./components/Addbackendtechstack";
export { default as Adddevopstechstack } from "./components/Adddevopstechstack";
export { default as Addruntime } from "./components/Addruntime";
export { default as Addtechstack } from "./components/Addtechstack";
export { default as Customruntime } from "./components/Customruntime";
export { default as Architecturedetails } from "./components/Architecturedetails";
export { default as Assetinsight } from "./components/Assetinsight";
export { default as Justification } from "./components/Justification";
